import { Component, ElementRef, OnInit, SecurityContext } from '@angular/core';
import {
  getFirstJointOffer,
  isResOrPrepaidCustomer,
  MobileProduct,
  Option,
  Pack,
  PlcCodes,
} from '@dch/products-business-logic';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
  getSplitUnbilledBalance,
  getUserProduct,
} from '../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import {
  CustomerService,
  InceptionService,
  TranslationService,
} from '@proximus/ng-common';
import {
  GetEBUProductDetails,
  GetProductDetails,
} from '../../../../store/actions/product-details.actions';
import {
  getPiiBrand,
  getPiiMyMobile,
  getPiiServiceId,
  savePii,
} from '../../../../shared/pii/pii.utils';
import { CustomerAccount } from '@proximus/common-business-logic';
import { Product as UsageProduct } from '@proximus/usage-business-logic';
import {
  getUsageProductFrom,
  overrideSessionStorageOnEmptyHistory,
} from 'src/app/shared/usage/util';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { combineLatest } from 'rxjs';
import { GetSplitUnbilledBalance } from 'src/app/store/actions/split-unbilled-balence.actions';
import { BrandService } from '../../../../services/brand.service';
import { GetProducts } from '../../../../store/actions/products.actions';
import { isAu } from '../../../../shared/customer-account/customer-account.utils';
import { filter } from 'rxjs/operators';
import { EwebTokenService } from '../../../../services/eweb-token.service';

declare let inception;

@Component({
  selector: 'mprd-mobile-level-two',
  templateUrl: './mobile-level-two.component.html',
})
export class MobileLevelTwoComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: MobileProduct;
  usageProduct: UsageProduct;
  isRes: boolean;
  customerAccount: CustomerAccount;
  fragmentId: string;
  hasError: boolean;
  isPending: boolean;
  isUr: boolean;
  isAu: boolean;
  isEBU: boolean;
  isMyMobile: boolean;
  isUrBuyingEnabled: boolean;
  remainingDaysLabel: string;
  showBipt = false;
  splitBillData: any;
  isScarlet: boolean;
  private isPrepaid: boolean;
  private hasCustomerId: boolean;

  savePii = savePii;
  jointOffer: Option;

  faqHtml?: string;
  isProductOfferEligibleForPenalty = false;

  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private customerService: CustomerService,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private brandService: BrandService,
    private readonly ewebTokenService: EwebTokenService
  ) {
    super();
  }

  get showAllAvailableOptions(): boolean {
    const isEshareMobileOptionFlowEnabled =
      this.translationService.getTranslatedValueFor(
        'eshare.mobile.enableOptionFlowRedirect',
      ) === 'true';

    return !isEshareMobileOptionFlowEnabled || this.isPrepaid || !this.hasCustomerId;
  }


  ngOnInit(): void {
    if (this.isADeeplink() || this.translationService.getTranslatedValueFor('eshare.mobile.enableOptionFlowRedirect') === 'true') {
      this.store.dispatch(new GetProducts());
    }

    if (this.isADeeplink()) {
      this.addSubscription(
        this.store.select(getUserProduct).subscribe((userProduct) => {
          if (
            userProduct &&
            ((userProduct.packs && userProduct.packs.length > 0) ||
              (userProduct.outOfPacks && userProduct.outOfPacks.length > 0))
          ) {
            const mobileProductsAvailableForDeepLink =
              this.getMobileProductsAvailableForDeepLink(
                userProduct.packs,
                userProduct.outOfPacks,
              );

            if (
              !mobileProductsAvailableForDeepLink ||
              mobileProductsAvailableForDeepLink.length !== 1
            ) {
              this.routeToOverview();
            } else {
              this.loadSelectedMobileProductDetails(
                mobileProductsAvailableForDeepLink[0].accessNumber,
              );
            }
          }
        }),
      );
    } else {
      this.loadMobileProduct();
    }
  }

  initBipt() {
    this.initMasonry();
    this.showBipt = true;
  }

  initMasonry() {
    setTimeout(() => {
      inception.masonry('[data-masonry-container]');
    });
  }

  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
      if (this.fragmentId) {
        this.inceptionService.scrollToElement('#' + this.fragmentId);
      }
    }
    this.initMasonry();
  }

  onClickPersonalizedOptionsCtaBanner() {
    this.addSubscription(this.ewebTokenService.getRedirectToEshareOptionFlowUrl(
      PlcCodes.MV,
      null,
      getPiiServiceId()
    ).subscribe((redirectUrl: string) => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }));
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }

  private scrollToFragment(): void {
    setTimeout(() => {
      if (this.fragmentId) {
        this.inceptionService.scrollToElement('#' + this.fragmentId);
      } else {
        this.inceptionService.scrollToElement('#mobileLevelTwo');
      }
    });
  }

  private loadMobileProduct(): void {
    const serviceId = getPiiServiceId();
    const isNotFullControlBrand = getPiiBrand() !== 'bonefullcontrol';
    this.isMyMobile = getPiiMyMobile();
    this.isScarlet = this.brandService.isScarlet();
    this.isUrBuyingEnabled =
      this.translationService.getTranslatedValueFor(
        'mobile.urbuying.enabled',
      ) === 'true';
    if (serviceId) {
      this.addSubscription(
        combineLatest([
          this.route.params,
          this.customerService.getCustomerAccount(),
        ]).subscribe((res) => {
          const customerAccount = res[1];
          if (customerAccount) {
            this.customerAccount = customerAccount;
            this.isRes = isResOrPrepaidCustomer(customerAccount);
            this.isUr = this.customerAccount.isUr();
            this.isEBU = this.customerAccount.isEBU();
            this.isAu = isAu(this.customerAccount);
            this.isPrepaid = this.customerAccount.isPrepaid();
            this.hasCustomerId = !!customerAccount.getSelectedCustomer()?.customerId;
            if (this.isEBU) {
              this.store.dispatch(new GetSplitUnbilledBalance({ serviceId }));
              this.store.dispatch(
                new GetEBUProductDetails({
                  productType: 'mobile',
                  serviceId,
                }),
              );
            } else {
              this.store.dispatch(
                new GetProductDetails({
                  productType: 'mobile',
                  serviceId,
                  isNotFullControlBrand,
                }),
              );
            }
          }
        }),
      );

      this.addSubscription(
        this.route.fragment.subscribe((fragment) => {
          this.fragmentId = fragment;
        }),
      );

      this.scrollToFragment();

      const url = 'mobile-details-faq%7EmgnlArea=body%7E.html';
      this.http.get(url, { responseType: 'text' }).subscribe((response) => {
        this.faqHtml = this.sanitizer.sanitize(SecurityContext.HTML, response);
      });

      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.mobileProductDetails) {
            this.selectedProduct = value.mobileProductDetails;
            if (this.selectedProduct) {
              this.usageProduct = getUsageProductFrom(this.selectedProduct);
              this.jointOffer = getFirstJointOffer(this.selectedProduct);
              this.isProductOfferEligibleForPenalty =
                !!this.jointOffer?.isProductOfferEligibleForPenalty;
            }
          }
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );

      this.addSubscription(
        this.store.select(getProductDetailsPending).subscribe((pending) => {
          this.isPending = pending;
        }),
      );

       this.addSubscription(
        combineLatest([
          this.store.select(getSelectedProductDetails),
          this.store.select(getSplitUnbilledBalance),
        ])
          .pipe(
            filter(
              ([productDetails, splitBillData]) =>
                !!productDetails?.mobileProductDetails && !!splitBillData
            )
          )
          .subscribe(([productDetails, splitBillData]) => {


            if (this.isEBU && splitBillData && this.updateExceedingAmountVisibility(
              productDetails.mobileProductDetails.productId
            )) {
              this.splitBillData = splitBillData;
            }
          })
      );

      this.translationService.parse(this.elementRef.nativeElement);
    } else {
      overrideSessionStorageOnEmptyHistory(
        window.location.href?.replace('details/mobile', 'overview'),
      );
      this.router.navigate(['/overview']);
    }
  }
  private updateExceedingAmountVisibility(mobileProductId: string): boolean {
    const excludedProductIds = this.translationService
    .getTranslatedValueFor('products.overview.Ebu.exceedingBillNotShown.productIds')
    ?.split(',') || [];
  return !excludedProductIds.includes(mobileProductId);
  }

  private isADeeplink() {
    return this.router.url.includes('/deeplink');
  }
  private loadSelectedMobileProductDetails(accessNumber: string): void {
    savePii(accessNumber);
    this.loadMobileProduct();
  }

  private getMobileProductsAvailableForDeepLink(
    packs: Pack[],
    outOfPacks: Pack[],
  ): MobileProduct[] {
    const mobileProducts: MobileProduct[] = [];

    packs.forEach((pack) => {
      const mobileProduct = pack?.coreProducts?.filter(
        (product) => product && product.plc === PlcCodes.MV,
      ) as MobileProduct[];
      mobileProducts.push(...mobileProduct);
    });

    outOfPacks.forEach((outOfpack) => {
      const mobileProduct = outOfpack?.coreProducts?.filter(
        (product) => product && product.plc === PlcCodes.MV,
      ) as MobileProduct[];
      mobileProducts.push(...mobileProduct);
    });

    return mobileProducts;
  }
}
